import React from 'react';
import { Layout } from '../components/Layout';
import { ShieldX, ArrowLeft, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';

export const NoPermissionPage = ({ pageName }) => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="flex items-center justify-center min-h-[60vh]" data-testid="no-permission-page">
        <div className="text-center max-w-md mx-auto p-8">
          <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-red-100 flex items-center justify-center">
            <ShieldX className="h-12 w-12 text-red-500" />
          </div>
          
          <h1 className="text-3xl font-bold text-slate-900 mb-4">
            Nemáte oprávnění
          </h1>
          
          <p className="text-lg text-slate-600 mb-2">
            Přístup k této stránce je omezen.
          </p>
          
          {pageName && (
            <p className="text-slate-500 mb-8">
              Stránka: <span className="font-medium text-slate-700">{pageName}</span>
            </p>
          )}
          
          <p className="text-sm text-slate-500 mb-8">
            Pokud si myslíte, že byste měli mít přístup, kontaktujte administrátora systému.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              variant="outline"
              onClick={() => navigate(-1)}
              className="border-slate-300"
              data-testid="go-back-button"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Zpět
            </Button>
            
            <Button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-cyan-500 to-emerald-500 hover:from-cyan-600 hover:to-emerald-600"
              data-testid="go-home-button"
            >
              <Home className="h-4 w-4 mr-2" />
              Na úvodní stránku
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NoPermissionPage;
